module.exports = __webpack_public_path__ + "static/media/1988-Parrot-icon.e70f6a0a.png";